import cx from 'classnames';
import dynamic from 'next/dynamic';
import { memo, useContext } from 'react';
import HeroData from '@/vdp/Hero/HeroData';
import { globalError } from '~/constants/errorBoundaryEvents';
import Section, { SectionId, SectionName } from '~/constants/vdp/section';
import { SectionAnalyticsProvider } from '~/context/vdp/SectionAnalyticsContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import useShouldRenderCondensedHero from '~/hooks/vdp/useShouldRenderCondensedHero';
import {
  ErrorBoundaryFallbackComponentProps,
  withErrorBoundary
} from '~/utilities/ErrorBoundary';
import { generateErrorLogger } from '~/utilities/loggers';

const CondensedHero = dynamic(
  () => import(/* webpackChunkName: "CondensedHero" */ './Condensed/Hero')
);

const SpinnerHero = dynamic(
  () => import(/* webpackChunkName: "SpinnerHero" */ './SpinnerHero')
);

function Hero() {
  const { hasEverLoaded } = useContext(UserVehicleContext).vehicleAvailability;
  const isCondensedLayout = useShouldRenderCondensedHero();

  return (
    <SectionAnalyticsProvider analyticsId={SectionName.Hero}>
      <HeroData />
      <div
        className={cx(
          'md:col-span-1',
          'transition-all',
          hasEverLoaded ? 'aspect-auto' : 'aspect-video',
          hasEverLoaded ? 'opacity-100' : 'sm:opacity-0',
          hasEverLoaded && isCondensedLayout ? 'sm:col-span-1' : 'sm:col-span-2'
        )}
        data-nav-section={SectionId.Hero}
      >
        {isCondensedLayout ? <CondensedHero /> : <SpinnerHero />}
      </div>
    </SectionAnalyticsProvider>
  );
}

const FallbackComponent = (_: ErrorBoundaryFallbackComponentProps) => null;

export default withErrorBoundary(
  memo(Hero),
  FallbackComponent,
  generateErrorLogger(globalError),
  Section.Hero
);
